import React from "react";
import Navbar from "../components/navbar/Navbar";
import CustomizedTables from "../components/tabela/CustomizedTables";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useContext, useRef } from "react";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import IconButton from "@material-ui/core/IconButton";
import Valoreconomico from "../components/noticias/Valoreconomico";
import Box from "@material-ui/core/Box";
import MinhaOrdens from "../components/tabela/MinhaOrdens";
import TabelaQuote from "../components/tabela/TabelaQuote";
import NegocioExecutado from "../components/tabela/NegocioExecutado";
import Chartslline from "../components/charts/Chartslline";
import { AuthContext } from "../../context/AuthContex";
import { CircularProgress, Select } from "@material-ui/core";
import mainData from "../components/charts/candleChart/Data";
import Tooltip from "@material-ui/core/Tooltip";
import "./sala.css";
import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import Interweave from "interweave";

import axios from "axios";
import { set, setDate } from "date-fns/esm";
import ChartJS from "../components/charts/candleChart/ChartJS";
import AreaChart from "../components/charts/areaChart/AreaChart";
import Chart from "react-stockcharts/lib/Chart";
import "./../components/resizableCss/style.css";
import { Resizable } from "react-resizable";
export default function Sala() {
  const { user } = useContext(AuthContext);
  const [chartsToDisplay, setChartsToDisplay] = useState([]);
  const [modalinfo, setModalinfo] = useState(false);
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PS = process.env.REACT_APP_PUBLIC_SERVER;
  const [ot_tx, setot_tx] = useState([]);
  const [loader, setloader] = useState(true);
  const [contaloader, setContaloader] = useState(false);
  const [states, setstates] = useState(true);
  const [state, setState] = useState({
    width: 200,
    height: 200,
  });
  const [date, setdate] = useState("2021-06-23");
  const [titulo, settitulo] = useState("ottx");
  const [viewforma, setviewforma] = useState("dia");
  const [valoreconomiconews, setvaloreconomiconews] = useState([]);
  const [inactive, setInactive] = useState(true);
  const [inactiveCarteira, setinactiveCarteira] = useState(true);
  const [ordemActivo, setordemActivo] = useState("612c99bfc328ab3014c62086");
  const [contaEma, setcontaEma] = useState(true);
  const [graphsimbols, setgraphsimbols] = useState(false);
  const [buySellPanel, setbuySellPanel] = useState(true);
  const [carteira, setcarteira] = useState(0);
  const [negociacoes, setNegociacoes] = useState([]);
  const [pagenumber, setpagenumber] = useState(0);
  const [tipodenegocio, settipodenegocio] = useState("BT");
  const [precocompra, setprecocompra] = useState(12);
  const [nomedegocio, setnomedegocio] = useState("BT");
  const [ordens, setordens] = useState([]);
  const [negocioactivo, setnegocioactivo] = useState([]);
  const quantidade_total = useRef();
  var negocio = [];
  negocio.list = [];

  var allOrdnes = [];
  const charts = [];
  const CandlechartType = async () => {
    charts.push(
      <ChartJS key={1} width="1200" data={MadeData} modal={modalinfo} />
    );
    setChartsToDisplay(charts);
  };

  const AreachartType = async () => {
    charts.push(
      <AreaChart key={1} width="1200" data={MadeData} modal={modalinfo} />
    );
    setChartsToDisplay(charts);
  };

  var MadeData = mainData;

  useEffect(() => {
    const buscarOrdens = async () => {
      try {
        const res = await axios.get("ordem/usuario/" + user._id);
        setordens(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    buscarOrdens();
  });

  useEffect(() => {
    const getOrders = async () => {
      charts.push(
        <AreaChart key={1} width="1200" data={MadeData} modal={modalinfo} />
      );
      setChartsToDisplay(charts);
      // try {
      //   const res = await axios.get("negocios/" + ordemActivo);
      //   for (let index = 0; index < res.data.length; index++) {
      //     MadeData.push({
      //       date: new Date(res.data[index].date),
      //       open: res.data[index].open,
      //       high: res.data[index].high,
      //       low: res.data[index].low,
      //       close: res.data[index].close,
      //     });

      //     if (index == res.data.length - 1) {
      //       charts.push(
      //         <AreaChart
      //           key={1}
      //           width="1200"
      //           data={MadeData}
      //           modal={modalinfo}
      //         />
      //       );
      //       setChartsToDisplay(charts);
      //     }
      //   }
      // } catch (err) {
      //   console.log(err);
      // }
    };
    getOrders();
  }, [ordemActivo]);
  var pagination = "";
  const indexOfLast = negocio.currentpage * negocio.perpage;
  const indexOfFirst = indexOfLast - negocio.perpage;
  var currentTodos = [];
  var renderTodos;
  useEffect(() => {
    const getNegocios = async () => {
      const res = await axios.get("engine/allNegocios");
      setNegociacoes(res.data);
      for (let index = 0; index < res.data.length; index++) {
        if (res.data[index].tipo_de_instrumento == tipodenegocio) {
          negocio.list.push(res.data[index]);
        }
      }
    };
    getNegocios();
  }, [tipodenegocio]);

  const selectorden = (variable, idordem) => {
    MadeData = mainData;
    setordemActivo(idordem);

    document.querySelectorAll(".ordens").forEach((el) => {
      el.classList.remove("btn-warning");
      el.classList.remove("btn-secondary");
      el.classList.add("btn-secondary");
    });

    document.querySelectorAll("#" + variable).forEach((el) => {
      el.classList.add("btn-warning");
    });
  };

  useEffect(() => {
    const getvaloreconomiconews = async () => {
      try {
        const res = await axios.get("scraper/valoreconomico-empresas-negocios");
        setvaloreconomiconews(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getvaloreconomiconews();
  }, [states]);

  useEffect(() => {
    const getrelatorio = async () => {
      setloader(false);
      const d = new Date(date);
      const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
      const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(d);
      const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
      try {
        const res = await axios.get("pdf/" + titulo + "/" + ye + mo + da);
        setot_tx(res.data);
        console.log(ye + mo);
        setloader(true);
      } catch (err) {
        console.log(err);
      }
    };
    getrelatorio();
  }, [date, titulo]);

  const fetchUser = async () => {
    const res = await axios.get("usuarios?userId=" + user._id);
    if (!contaEma) {
      setcarteira(res.data.carteira);
    } else {
      setcarteira(res.data.carteiraDemo);
    }
    setContaloader(false);
  };
  fetchUser();

  const Depositar = async () => {
    setContaloader(true);
    if (!contaEma) {
      alert("depositar");
    } else {
      const contaUpdate = { userId: user._id, carteiraDemo: 500000 };
      try {
        await axios.put("usuarios/" + user._id, contaUpdate);
        fetchUser();
      } catch (err) {
        console.log(err);
      }
    }
  };

  // On top layout
  const onResize = (event, { element, size, handle }) => {
    setState({
      width: size.width,
      height: size.height,
    });
  };

  const Deactivate = () => {
    if (graphsimbols) {
      setgraphsimbols(!graphsimbols);
    }
    if (!inactive) {
      setInactive(!inactive);
    }
    if (!inactiveCarteira) {
      setinactiveCarteira(!inactiveCarteira);
    }
  };

  const selectNegocio = (negocio) => {
    setnegocioactivo(negocio);
    console.log(negocio);
    setprecocompra(negocio.preco_unitario);
    if (negocio.nome_da_empresa) {
      setnomedegocio(negocio.nome_da_empresa);
    } else {
      setnomedegocio(negocio.tipo_de_instrumento + " " + negocio.isin);
    }
  };

  const manageCompra = async () => {
    var valor = 0;
    valor =
      Number(negocioactivo.preco_unitario) *
      Number(quantidade_total.current.value);

    const ordem = {
      id_cliente: user._id,
      codigo_de_negociacao: negocioactivo._id,
      tipo_ordem: "market",
      lado_de_ordem: "bid",
      quantidade_total: negocioactivo.preco_unitario,
      tipo_de_instrumento: negocioactivo.tipo_de_instrumento,
      preco_unitario: negocioactivo.preco_unitario,
    };

    if (Number(carteira) >= valor) {
      const contaUpdate = {
        userId: user._id,
        carteiraDemo: Number(carteira) - valor,
      };
      try {
        const res = await axios.post("engine/newOrder", ordem);
        await axios.put("usuarios/" + user._id, contaUpdate);
        fetchUser();
      } catch (err) {
        console.log(err);
      }
    } else {
      alert("Dinheiro Insuficiente!");
    }

    // try {
    //
    // } catch (err) {
    //   console.log(err);
    // }
  };

  return (
    <>
      <div className={`painel-titulos card ${inactive ? "inactive" : ""}`}>
        <div className="card-header"></div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-4 mb-2 mb-sm-0">
              <div
                className="nav flex-column nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <label htmlFor="">Titulos de Tesouro</label>
                <a
                  className="nav-link active show"
                  id="v-pills-home-tab"
                  data-bs-toggle="pill"
                  href="#v-pills-home"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected="true"
                  onClick={() => settipodenegocio("BT")}
                >
                  <i className="mdi mdi-home-variant d-md-none d-block"></i>
                  <span className="d-none d-md-block">BT</span>
                </a>
                <a
                  className="nav-link"
                  id="v-pills-profile-tab"
                  data-bs-toggle="pill"
                  href="#v-pills-profile"
                  role="tab"
                  aria-controls="v-pills-profile"
                  aria-selected="false"
                  onClick={() => settipodenegocio("OT-NR")}
                >
                  <i className="mdi mdi-account-circle d-md-none d-block"></i>
                  <span className="d-none d-md-block">OT-NR</span>
                </a>
                <label className="mt-2">Mercado</label>
                <a
                  className="nav-link"
                  id="v-pills-settings-tab"
                  data-bs-toggle="pill"
                  href="#v-pills-settings"
                  role="tab"
                  aria-controls="v-pills-settings"
                  aria-selected="false"
                  onClick={() => settipodenegocio("Acções")}
                >
                  <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                  <span className="d-none d-md-block">Acções</span>
                </a>
              </div>
            </div>

            <div className="col-sm-8 scrolltitulos">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                >
                  <p className="mb-0">
                    <ul class="list-group">
                      {negociacoes.map((n) =>
                        n.tipo_de_instrumento == "BT" ? (
                          <li
                            className="list-group-item list-group-item-action"
                            onClick={() => {
                              selectNegocio(n);
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>{n.isin}</span>
                            <span style={{ marginLeft: "20px" }}>
                              {" "}
                              {n.preco_unitario} kz
                            </span>

                            <span style={{ marginLeft: "20px" }}>
                              {" "}
                              <i className="bi bi-arrow-down-up text-success"></i>{" "}
                              {n.rentabilidade_cupao}%
                            </span>
                          </li>
                        ) : (
                          ""
                        )
                      )}
                    </ul>
                  </p>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <p className="mb-0">
                    <p className="mb-0">
                      <ul class="list-group">
                        <ul class="list-group">
                          {negociacoes.map((n) =>
                            n.tipo_de_instrumento == "OT-NR" ? (
                              <li
                                className="list-group-item list-group-item-action"
                                onClick={() => {
                                  selectNegocio(n);
                                }}
                              >
                                {n.isin}
                                <span style={{ marginLeft: "20px" }}>
                                  {" "}
                                  {n.preco_unitario} kz
                                </span>

                                <span style={{ marginLeft: "20px" }}>
                                  {" "}
                                  <i className="bi bi-arrow-down-up text-success"></i>{" "}
                                  {n.rentabilidade_cupao}%
                                </span>
                              </li>
                            ) : (
                              ""
                            )
                          )}
                        </ul>
                      </ul>
                    </p>
                  </p>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                >
                  <p className="mb-0">
                    <p className="mb-0">
                      <ul class="list-group">
                        {negociacoes.map((n, i) =>
                          n.tipo_de_instrumento == "Acções" ? (
                            <li
                              key={i}
                              className="list-group-item list-group-item-action"
                              onClick={() => {
                                selectNegocio(n);
                              }}
                            >
                              <span
                                style={{
                                  marginRight: "20px",
                                  fontWeight: "bold",
                                }}
                              >
                                {n.tipo_de_empresa}
                              </span>
                              {n.cod_de_negociacao}
                              <span
                                style={{
                                  marginLeft: "20px",
                                }}
                              >
                                {" "}
                                {n.preco_unitario} kz
                              </span>
                            </li>
                          ) : (
                            ""
                          )
                        )}
                      </ul>
                    </p>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`painel-carteiras card ${
          inactiveCarteira ? "inactiveCarteria" : ""
        }`}
      >
        <div className="card-header"></div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-4 mb-2 mb-sm-0">
              <div
                className="nav flex-column nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <a
                  className="nav-link active show"
                  id="v-pills-home-tab"
                  data-bs-toggle="pill"
                  href="#v-pills-home"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected="true"
                  onClick={() => settipodenegocio("BT")}
                >
                  <i className="mdi mdi-home-variant d-md-none d-block"></i>
                  <span className="d-none d-md-block">Minhas Ordens</span>
                </a>
              </div>
            </div>

            <div className="col-sm-8 scrolltitulos">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                >
                  <p className="mb-0">
                    <table className="table table-hover  table-sm text-white">
                      <thead>
                        <tr>
                          <th>Código</th>
                          <th>Qty</th>
                          <th>Estado</th>
                          <th>Alterar</th>
                          <th>Eliminar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ordens.map((row) => (
                          <tr key={row._id} style={{ color: "white" }}>
                            <td scope="row">{row.codigo_de_negociacao}</td>
                            <td>{row.quantidade_total}</td>
                            <td>Pendente</td>
                            <td>
                              <button
                                // onClick={() => handleClickOpen(row)}
                                className="btn btn-outline-info btn-rounded"
                              >
                                <i className="uil-edit"></i>
                              </button>
                            </td>

                            <td>
                              <button
                                // onClick={() => eliminarOrdens(row._id)}
                                className="btn btn-outline-danger btn-rounded"
                              >
                                <i className="uil-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="row"
        onClick={() => Deactivate()}
        style={{
          color: "white",
          height: " 100%",
          backgroundImage: "url(" + PS + "map2.png)",
          /* Center and scale the image nicely */
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        {/* <div className="col-md-3">
          {" "}
          <div className="col-md-8">
            <div className="card-body">
              {" "}
              <div className="card-header text-center">quantidade</div>
              <input
                style={{ fontSize: "10px" }}
                className="form-control"
                type="number"
                name=""
                id=""
              />
            </div>
          </div>
        </div>
 
        <div className="col-md-3" style={{ marginLeft: "-150px" }}>
          <div className="col-md-8">
            <div className="card-body">
              <div
                className="card-header text-center"
                style={{ height: "78px" }}
              >
                fecho <br /> automático
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3" style={{ marginLeft: "-168px" }}>
          <div className="card-body col-md-8">
            <input
              className="form-control"
              type="number"
              placeholder="Stop loss"
              style={{ height: "39px", fontSize: "10px" }}
            />
            <input
              className="form-control"
              type="number"
              placeholder="Take gain"
              style={{ height: "39px", fontSize: "10px" }}
            />
          </div>
        </div>

        <div className="col-md-3" style={{ marginLeft: "-110px" }}>
          <p style={{ marginTop: "33px" }}>
            <a
              onClick={() => setInactive(!inactive)}
              style={{ height: "60px" }}
              className="btn btn-warning"
              data-bs-toggle="collapse"
              href="#multiCollapseExample1"
              role="button"
              aria-expanded="false"
              aria-controls="multiCollapseExample1"
            >
              <div style={{ verticalAlign: "center" }}>
                <i style={{ fontSize: "30px" }} className="bi bi-plus"></i>
              </div>
            </a>
            <span className={`money-carteira ${contaEma ? "" : "activo"}`}>
              {contaloader ? (
                <div className="text-center">
                  <CircularProgress color="green" size="20px" />
                </div>
              ) : (
                <NumberFormat
                  value={carteira}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={" Kz"}
                  className="conta-dinheiro"
                  decimalSeparator={"."}
                />
              )}

              <div>
                <button
                  className={`btn ${contaEma ? "btn-warning" : "btn-info"}`}
                  onClick={() => Depositar()}
                >
                  {contaEma ? "rechear conta demo" : "Depositar"}
                </button>{" "}
                <button
                  className={`btn ${contaEma ? "btn-success" : "btn-warning"}`}
                  onClick={() => setcontaEma(!contaEma)}
                >
                  {contaEma ? "conta verdadeira" : "conta Demo"}
                </button>
              </div>
            </span>
          </p>
          <div className={`painel-titulos card ${inactive ? "inactive" : ""}`}>
            <div className="card-header"></div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-4 mb-2 mb-sm-0">
                  <div
                    className="nav flex-column nav-pills"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <label htmlFor="">Titulos de Tesouro</label>
                    <a
                      className="nav-link active show"
                      id="v-pills-home-tab"
                      data-bs-toggle="pill"
                      href="#v-pills-home"
                      role="tab"
                      aria-controls="v-pills-home"
                      aria-selected="true"
                    >
                      <i className="mdi mdi-home-variant d-md-none d-block"></i>
                      <span className="d-none d-md-block">BT/OT-NR</span>
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-profile-tab"
                      data-bs-toggle="pill"
                      href="#v-pills-profile"
                      role="tab"
                      aria-controls="v-pills-profile"
                      aria-selected="false"
                    >
                      <i className="mdi mdi-account-circle d-md-none d-block"></i>
                      <span className="d-none d-md-block">OT-TX</span>
                    </a>
                    <label className="mt-2">Mercado</label>
                    <a
                      className="nav-link"
                      id="v-pills-settings-tab"
                      data-bs-toggle="pill"
                      href="#v-pills-settings"
                      role="tab"
                      aria-controls="v-pills-settings"
                      aria-selected="false"
                    >
                      <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                      <span className="d-none d-md-block">Acções</span>
                    </a>
                  </div>
                </div>

                <div className="col-sm-8">
                  <div className="tab-content" id="v-pills-tabContent">
                    <div
                      className="tab-pane fade active show"
                      id="v-pills-home"
                      role="tabpanel"
                      aria-labelledby="v-pills-home-tab"
                    >
                      <p className="mb-0">
                        <ul class="list-group">
                          <li className="list-group-item list-group-item-action">
                            OU1145{" "}
                            <span style={{ marginLeft: "40px" }}>
                              {" "}
                              <i className="bi bi-arrow-down-up text-success"></i>{" "}
                              66%
                            </span>
                          </li>
                          <li className="list-group-item list-group-item-action">
                            AU4554{" "}
                            <span style={{ marginLeft: "40px" }}>
                              {" "}
                              <i className="bi bi-arrow-down-up text-success"></i>{" "}
                              72%
                            </span>
                          </li>
                          <li className="list-group-item list-group-item-action">
                            YIJ6564{" "}
                            <span style={{ marginLeft: "40px" }}>
                              {" "}
                              <i className="bi bi-arrow-down-up text-warning"></i>{" "}
                              48%
                            </span>
                          </li>
                          <li className="list-group-item list-group-item-action">
                            AO46546{" "}
                            <span style={{ marginLeft: "40px" }}>
                              {" "}
                              <i className="bi bi-arrow-down-up text-warning"></i>{" "}
                              42%
                            </span>
                          </li>
                          <li className="list-group-item list-group-item-action">
                            OU5645{" "}
                            <span style={{ marginLeft: "40px" }}>
                              {" "}
                              <i className="bi bi-arrow-down-up text-danger"></i>{" "}
                              2%
                            </span>
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="v-pills-profile"
                      role="tabpanel"
                      aria-labelledby="v-pills-profile-tab"
                    >
                      <p className="mb-0">
                        <p className="mb-0">
                          <ul class="list-group">
                            <li className="list-group-item list-group-item-action">
                              OGH1145{" "}
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-danger"></i>{" "}
                                12%
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              AUEGT54{" "}
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-success"></i>{" "}
                                89%{" "}
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              YSDF564{" "}
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-success"></i>{" "}
                                66%{" "}
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              AO46546{" "}
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-danger"></i>{" "}
                                18%{" "}
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              OPDF645{" "}
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-warning"></i>{" "}
                                49%{" "}
                              </span>
                            </li>
                          </ul>
                        </p>
                      </p>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="v-pills-settings"
                      role="tabpanel"
                      aria-labelledby="v-pills-settings-tab"
                    >
                      <p className="mb-0">
                        <p className="mb-0">
                          <ul class="list-group">
                            <li className="list-group-item list-group-item-action">
                              <i className="uil-google-drive-alt me-1"></i>{" "}
                              Google Drive
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-success"></i>{" "}
                                99%
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              <i className="uil-facebook-messenger me-1"></i>{" "}
                              Facebook Messenger
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-danger"></i>{" "}
                                12%
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              <i className="uil-apple me-1"></i> Apple
                              Technology Company
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-warnig"></i>{" "}
                                34%
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              <i className="uil-intercom me-1"></i> Intercom
                              Support System{" "}
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-danger"></i>{" "}
                                1%
                              </span>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              <i className="uil-paypal me-1"></i> Paypal Payment
                              Gateway{" "}
                              <span style={{ marginLeft: "40px" }}>
                                {" "}
                                <i className="bi bi-arrow-down-up text-success"></i>{" "}
                                82%
                              </span>
                            </li>
                          </ul>
                        </p>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="col-md-10">
          <div>
            {" "}
            {buySellPanel ? (
              <>
                <button
                  className="btn btn-sm btn-success"
                  style={{
                    fontSize: "12px",
                    marginTop: "-4px",
                    height: "20px",
                    verticalAlign: "middle",
                  }}
                  onClick={() => manageCompra()}
                >
                  COMPRAR
                </button>
                <input
                  type="number"
                  name=""
                  id=""
                  ref={quantidade_total}
                  placeholder="0.1"
                  style={{
                    width: "54px",
                    height: "21px",
                    textAlign: "right",
                  }}
                />
                <button
                  className="btn btn-sm btn-danger"
                  style={{
                    height: "20px",
                    marginTop: "-4px",
                    fontSize: "12px",
                    verticalAlign: "middle",
                  }}
                >
                  VENDER
                </button>
                <input
                  type="text"
                  name=""
                  id=""
                  placeholder="PM"
                  style={{ width: "30px", marginLeft: "5px" }}
                  readOnly
                />
                <input
                  type="Number"
                  name=""
                  placeholder="0"
                  id=""
                  style={{ width: "54px" }}
                />
                <div style={{ marginTop: "-5px" }}>
                  <input
                    type="text"
                    name=""
                    id=""
                    value={precocompra}
                    style={{
                      width: "109px",
                      color: "#38B385",
                      border: "solid #38B385",
                      height: "21px",
                      textAlign: "center",
                    }}
                    readOnly
                  />
                  <input
                    type="text"
                    name=""
                    id=""
                    defaultValue="2.23"
                    style={{
                      width: "109px",
                      color: "#D55858",
                      border: "#D55858",
                      border: "solid",
                      height: "21px",
                      textAlign: "center",
                    }}
                    readOnly
                  />
                  <input
                    type="text"
                    name=""
                    id=""
                    placeholder="LM"
                    style={{
                      width: "30px",
                      marginLeft: "5px",
                      height: "21px",
                    }}
                    readOnly
                  />
                  <input
                    type="Number"
                    name=""
                    placeholder="0"
                    id=""
                    style={{ width: "54px", height: "21px" }}
                  />
                  <button
                    type="button"
                    class="btn btn-outline-info"
                    onClick={() => setbuySellPanel(!buySellPanel)}
                    style={{
                      marginTop: "-10px",
                      marginLeft: "3px",
                      border: "none",
                    }}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </button>{" "}
                </div>
              </>
            ) : (
              <button
                type="button"
                onClick={() => setbuySellPanel(!buySellPanel)}
                class="btn btn-outline-info"
                style={{
                  marginTop: "12px",
                  marginLeft: "3px",
                  border: "none",
                }}
              >
                <i class="bi bi-arrow-right-circle-fill"></i>
              </button>
            )}
            <span>{nomedegocio}</span>
          </div>
        </div>

        <div
          className="col-md-2"
          style={{ marginTop: "22px", marginLeft: "-65px" }}
        >
          <span className={`money-carteira ${contaEma ? "" : "activo"}`}>
            {contaloader ? (
              <div className="text-center">
                <CircularProgress color="green" size="20px" />
              </div>
            ) : (
              <NumberFormat
                value={carteira}
                displayType={"text"}
                thousandSeparator={true}
                suffix={"AOA"}
                className="conta-dinheiro"
                decimalSeparator={"."}
              />
            )}
          </span>
        </div>
        <div className="col-md-10" style={{ marginLeft: "-40px" }}>
          {chartsToDisplay}
        </div>
        <div className="col-md-2" style={{ marginLeft: "40px" }}>
          <div
            style={{
              marginLeft: "140px",
              marginTop: "10px",
            }}
          >
            <div>
              <Tooltip title="Depositar">
                <button
                  type="button"
                  className="btn btn-success btn-sm btn-rounded"
                  style={{ marginLeft: "-5px" }}
                >
                  <i className="bi bi-currency-exchange"></i>
                </button>
              </Tooltip>
            </div>

            <div style={{ marginTop: "10px" }}>
              <Tooltip title="Novo Ordem">
                <button
                  type="button"
                  onClick={() => setInactive(!inactive)}
                  className="btn btn-warning btn-sm btn-rounded"
                  style={{ marginLeft: "-5px" }}
                >
                  <span style={{ fontSize: "18px", fontWeight: "1000" }}>
                    +
                  </span>
                </button>
              </Tooltip>
            </div>

            <div style={{ marginTop: "30px" }}>
              <Tooltip title="Gráficos">
                <button
                  onClick={() => setgraphsimbols(!graphsimbols)}
                  type="button"
                  className="btn btn-info btn-sm btn-rounded"
                  style={{ marginLeft: "-5px" }}
                >
                  <i className="bi bi-bar-chart-fill"></i>
                </button>
              </Tooltip>
              {graphsimbols ? (
                <>
                  <div style={{ marginTop: "10px", marginLeft: "-6px" }}>
                    <Tooltip title="Gráfico de Volume">
                      <button
                        type="button"
                        onClick={() => AreachartType()}
                        className="btn btn-outline-primary btn-rounded"
                      >
                        <i className="mdi mdi-chart-areaspline"></i>
                      </button>
                    </Tooltip>
                  </div>
                  <div style={{ marginTop: "10px", marginLeft: "-6px" }}>
                    <Tooltip title="Gráfico de Candle">
                      <button
                        type="button"
                        className="btn btn-outline-success btn-rounded"
                        onClick={() => CandlechartType()}
                      >
                        <i className="uil uil-sliders-v text-danger"></i>
                      </button>
                    </Tooltip>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>

            <div style={{ marginTop: "10px" }}>
              <Tooltip title="Portfólio">
                <button
                  type="button"
                  onClick={() => setinactiveCarteira(!inactiveCarteira)}
                  className="btn btn-primary btn-sm btn-rounded"
                  style={{ marginLeft: "-5px" }}
                >
                  <i className="bi bi-person-bounding-box"></i>
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row" style={{ marginTop: "-9px", marginLeft: "40px" }}>
        <div className="col-md-12">
          {" "}
          <button
            id="otnr"
            type="button"
            class="btn btn-warning btn-sm ordens"
            style={{
              height: "19px",
              fontSize: "10px",
              fontWeight: "bold",
              marginRight: "5px",
            }}
            onClick={() => selectorden("otnr", "612c99bfc328ab3014c62086")}
          >
            OT-NR
          </button>
          <button
            id="bt"
            type="button"
            class="btn btn-secondary btn-sm ordens"
            style={{
              height: "19px",
              fontSize: "10px",
              fontWeight: "bold",
              marginRight: "5px",
            }}
            onClick={() => selectorden("bt", "613f2b4c8a7a47071408ad47")}
          >
            BT
          </button>
        </div>
      </div> */}
      {/* <Resizable
          height={state.height}
          width={state.width}
          onResize={onResize}
          resizeHandles={["ne"]}
        >
          <div
            className="col-md-6"
            style={{
              width: state.width + "px",
              height: state.height + "px",
              backgroundColor: "green",
            }}
          >
            <span>Contents</span>
          </div>
        </Resizable> */}
    </>
  );
}
